import type { RouterSlice } from 'app/app-state';
import { getCurrentBranch } from 'app/branches/selectors';
import type { BranchesSlice } from 'app/branches/types';
import { branding } from 'app/config';
import { getProjectState } from 'app/project/selectors';
import type { ProjectSlice } from 'app/project/types';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';
import { NotFoundError } from '../common/components/errors/index.js';
import { AppContainer, AppLayout, type AppLayoutProps } from './app-layout.js';
import { ErrorBoundary } from './error-boundary/index.js';

export function Router(props: AppLayoutProps): JSX.Element {
  const { router } = props;
  if (!router.result) {
    return (
      <AppContainer>
        <NotFoundError />
      </AppContainer>
    );
  }

  return (
    <DocumentTitle title={branding.productName}>
      <ErrorBoundary pathname={router.pathname}>
        <AppLayout {...props} />
      </ErrorBoundary>
    </DocumentTitle>
  );
}

export function mapStateToProps(state: RouterSlice & ProjectSlice & BranchesSlice): AppLayoutProps {
  const currentBranch = getCurrentBranch(state);
  const projectState = getProjectState(state);
  return {
    router: state.router,
    projectLoaded: projectState.loaded && Boolean(currentBranch?.runtimeSchema.data),
    error: projectState.error ?? currentBranch?.runtimeSchema.error
  };
}

export default connect(mapStateToProps)(Router);
